export default __webpack_public_path__ + "static/media/3-bm.1afcd100.webp";